export default {
  path: '/servico-de-pericia/:service_id',
  component: () => import('@/components/pages/ATServices/ExpertMode/ExpertModeMeters.vue')
}
